interface ItemOrder {
  isAdhoc?: boolean;
  peopleCount?: number;
  mealId?: unknown;
  drinkId?: unknown;
  meals?: { mealId?: unknown }[];
  drinks?: { drinkId?: unknown }[];
}
function countItems(order: ItemOrder, kind: "meal" | "drink"): number {
  const list: { mealId?: unknown; drinkId?: unknown }[] = kind === "meal" ? order.meals : order.drinks;
  const field = kind === "meal" ? "mealId" : "drinkId";
  if (list?.length) return list.filter(item => item[field]).length;
  return order[field] ? order.peopleCount || 1 : 0;
}
export const getMealCount = (order: ItemOrder) => order.isAdhoc ? countItems(order, "meal") : order.peopleCount || 0;
export const formatItemCounts = (meals: number, drinks: number) => `${meals} ${meals === 1 ? "meal" : "meals"} + ${drinks} ${drinks === 1 ? "drink" : "drinks"}`;
export const getItemSummary = (order: ItemOrder) => formatItemCounts(countItems(order, "meal"), countItems(order, "drink"));
